export const DRONES_API = '/api/v1/drones';
